import React from 'react';
import clsx from 'clsx';

import './index.scss';

import { onKeyDownFunc } from 'utils';

const ClickOnlyButton = ({ label, onClick, valid = false, color='blue' }) => {
   
  const onClickFunc = (e) => {
    onClick(e);
  };

  return (
    <div className={clsx('ClickOnlyButton', { valid })}>
      <div className={clsx('button-color', 
        { blue: color === 'blue' },
        { white: color === 'white' },
        { pink: color === 'pink' },
      )}>
        <button
          className="button"
          type="button"
          onClick={valid ? onClickFunc : () => { console.log('no valid'); }}
          onKeyDown={onKeyDownFunc}
        >
          {label}
        </button>
      </div>
    </div>
  );
};

export default ClickOnlyButton;